function pw_post_product_modal_save(personalisationID, thumbURL){

  $(".pwAddToCart").show();
  $(".pwAddToCart").prop("disabled", false);

  
  
  setTimeout(function(){ 
    var pw_cart_button_icon = $("#pw_cart_button svg");
    $('#pw_cart_button').val('Edit');
    $('#pw_cart_button').html('Edit ' + $(pw_cart_button_icon)[0].outerHTML);
    $(".pwAddToCart").show();
    $(".shopify-payment-button").hide();
  },1000);

}
document.addEventListener('DOMContentLoaded', function load() {
  
  
  	 var pw_button = $("#pw_cart_button");
     var staticProduct = $("#pw_static_product");
  
     if ($(".product").length && (pw_button.length || staticProduct.length) ){
        setTimeout(function(){ 
       		$(".shopify-payment-button").hide();
         },1000);
       
       $(document).on("change", ".selector-wrapper select", function(e){
       	$(".shopify-payment-button").hide();
       });
     }

    if($(".product").length && pw_button.length){
      $("body").addClass("pw-product");
        
      function personaliseButton(){

       /* $("body").on('DOMSubtreeModified', "#pw_personalisation_id", function() {

          var pw_button_text = $("#pw_cart_button").text();
          if(pw_button_text == "Personalise"){
            $('#pw_cart_button').text('Edit');
            setTimeout(function(){ 
              $(".pwAddToCart").show();
              $(".shopify-payment-button").hide();
            },1000);
          } 

        });*/


        // Select the node that will be observed for mutations
      /*  var targetNode = document.getElementById('pw_personalisation_id');

        // Options for the observer (which mutations to observe)
        var config = { attributes: true, childList: true };

        // Callback function to execute when mutations are observed
        var callback = function(mutationsList) {
          //for(var mutation of mutationsList) {
          for(var mutation in mutationsList) {

            var pw_button_text = $("#pw_cart_button").text();
            
            if(pw_button_text == "Personalise"){
              $('#pw_cart_button').text('Edit');
              setTimeout(function(){ 
                $(".pwAddToCart").show();
              },1000);
            }
          }

        };*/

        // Create an observer instance linked to the callback function
      /*  var observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);*/

        var pw_button = $("#pw_cart_button");
        if (typeof pw_button  !== "undefined"){
          setTimeout(function(){
            $(".shopify-payment-button, .pwAddToCart").hide();
          },3000);

        }
      }

      personaliseButton();

      $(".pwAddToCart").on("click", function(e){
          setTimeout(function(){ 
            var cardID = $("#pw_personalisation_id").val();
            if(cardID){
              var rand = Math.floor(Math.random() * 10000);
              var image_url = "https://pwcdn.net/thumbnails/1277/"+cardID+".jpg?r="+rand;
              $("#cart-notification #cart-notification-product img").attr("src", image_url);
            }
            
          
          },2000);
      });

      
       $(".product__media-toggle").on("click", function(e){
       
         setTimeout(function(){ 
             var cardID = $("#pw_personalisation_id").val();
            if(cardID){
                var rand = Math.floor(Math.random() * 10000);
                var image_url = "https://pwcdn.net/thumbnails/1277/"+cardID+".jpg?r="+rand;
               $(".product-media-modal__content img.product__media-item--variant.active").attr("src", image_url);
               $(".product-media-modal__content img.product__media-item--variant.active").attr("srcset", image_url);
            }
         },500);
       });
      function pwVariationChange(){

        var pw_cart_button = $("#pw_cart_button").html();
        if (typeof  pw_cart_button !== 'undefined'){
          var pw_button_text = $("#pw_cart_button").val();
          if(pw_button_text == "Edit"){
			            
            var product_image_original = $('meta[property="og:image"]').attr('content');
			
            setTimeout(function(){ 
    
                $(".product__media-wrapper li.product__media-item.is-active img").attr("data-src", product_image_original);
                $(".product__media-wrapper li.product__media-item.is-active img").attr("data-bgset", product_image_original);
                $(".product__media-wrapper li.product__media-item.is-active img").attr("src", product_image_original);
                $(".product__media-wrapper li.product__media-item.is-active img").attr("srcset", product_image_original);

            }, 500);
           
            if (document.documentMode || /Edge/.test(navigator.userAgent)) {
              $("#pw_cart_button").prop('value', 'Personalise');
            } else{
              $('#pw_cart_button').text('Personalise');
            }
            
          }
          
          setTimeout(function(){ 
              $(".shopify-payment-button, .pwAddToCart").hide();
           },500);
        }

      }
      
      $("fieldset.product-form__input input").on("click", function(e){
         pwVariationChange();
         setTimeout(function(){ 
            var getVariantID = $(".getVariantID").val();
            $("select.pwProductSelect option").removeAttr('selected');
            $('select.pwProductSelect option[value="' + getVariantID + '"]').attr('selected', 'selected');
         },500);

      });

    }
  	
  	function replacePWimages(){
      
      var textArray = $(".cart-items .cart-item .cart-item__details:contains('PersonalisationID')");

      textArray.each(function() {

        var cardID = this.innerText.match(/PersonalisationID:.*/);
        cardID = cardID[0];
        cardID = cardID.replace("PersonalisationID:", "").trim();
        cardID = cardID.match(/[^\s]+/);
        cardID = cardID[0];
        var rand = Math.floor(Math.random() * 10000);
        var newSrc = "https://pwcdn.net/thumbnails/1277/"+cardID+".jpg?r="+rand;
        $(this).parent().find("img").addClass("pwThumbImage");
        $(this).parent().find("img").attr("src",newSrc);
        $(this).parent().find("img").attr("srcset",newSrc);
      });
      
    }

    if ($(".cart-items").length){
      
      setTimeout(function(){ 
        //addEditOrderLink();
      	replacePWimages();
      }, 2000);
      
      $(document).on("click", ".icon-remove", function(){
        setTimeout(function(){ 
        	replacePWimages();
        },2000);
      });


      $("#pw_modal").on('hidden.bs.modal', function() { 
          
          setTimeout(function(){ 
              replacePWimages();
          },1000);
      });
  }

}, false);